import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Accordion from "react-bootstrap/Accordion"
import Card from "react-bootstrap/Card"
import Button from "react-bootstrap/Button"

const Contact = () => (
  <Layout>
    <Seo
      title="Alzheimers FAQs"
      description="Your Alzheimers Questions Answered here on how we care & what you can doto care for your loved one provided by Assured Assisted Living in Castle Rock CO"
    />
    <div className="page-headline blog-page">
      <div className="container">
        <div className="section-heading text-center">
          <h6 className="font-weight-bold text-uppercase flair">FAQs</h6>
          <h1>Your Alzheimers Questions Answered!</h1>
        </div>
      </div>
    </div>
    <div className="page-content faq">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-md-10 m-auto">
            <p>
              We know that Alzheimers, dementia, and memory loss can be a scary
              thing,w which is why we want to help you get your Alzheimers
              questions answered easily. We’ve laid out some of our most
              frequently asked questions here because we know you’re already
              asking these questions in your mind. Our team is also always
              available to answer your specific questions regarding Alzheimers,
              dementia, memory care, and the assisted living options associated
              with any of these situations.
            </p>
            <Accordion defaultActiveKey="0">
              <Card>
                <Card.Header>
                  <Accordion.Toggle as={Button} variant="link" eventKey="0">
                    What to look for when placing a loved one for long term
                    care?
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="0">
                  <div className="answer-body p-5">
                    <p>
                      When the time comes to place your loved one in a long-term
                      care facility, the decision can be difficult and often
                      overwhelming. Here are some questions you should ask at
                      each facility you inspect in order to ensure quality care:
                    </p>
                    <ul>
                      <li>
                        Is the staff happy and involved with the residents?
                      </li>
                      <li>
                        Is there a licensed nurse available to monitor resident
                        care and staff oversight?
                      </li>
                      <li>
                        What is the resident-to-direct care/caregiving staffing
                        ratio?
                      </li>
                      <li>
                        Do you see the residents restrained in wheelchairs,
                        unattended and looking over-medicated?
                      </li>
                      <li>
                        Are residents involved in activities designed to
                        eliminate feelings of boredom, loneliness and
                        helplessness?
                      </li>
                      <li>
                        Does the facility have outdoor areas for socialization
                        that are locked and accessible from the inside during
                        the day?
                      </li>
                      <li>Does the facility have pets?</li>
                      <li>
                        Is the pricing structure a fixed rate or “tiered
                        structure” with added unpredictable costs for increasing
                        levels of care?
                      </li>
                      <li>
                        What happens if my loved one’s physical condition or
                        behavior deteriorates?
                      </li>
                      <li>
                        What would be the circumstances or medical conditions
                        under which I would be required to move him/her?
                      </li>
                      <li>
                        Does the facility provide care to residents at all
                        stages of dementia-from early stages through hospice?
                      </li>
                      <li>
                        Does the facility have at least two staff members on
                        duty to assist in transferring of non-ambulatory
                        residents?
                      </li>
                      <li>
                        How is the Living Environment? Is it familiar as a real
                        home? Are there any unpleasant odors? Are there planned
                        activities?
                      </li>
                      <li>
                        Are the residents dressed and out of bed by 9 a.m.?
                      </li>
                    </ul>
                  </div>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Card.Header>
                  <Accordion.Toggle as={Button} variant="link" eventKey="1">
                    What is Dementia?
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="1">
                  <div className="answer-body p-5">
                    <p>
                      Dementia is an umbrella term used to describe the loss of
                      cognitive or intellectual function. Many conditions can
                      cause dementia. Dementia related depression, drug
                      interactions, thyroid and other problems may be reversible
                      if detected early. That’s one reason it’s important to
                      obtain a professsional assessment, so that the actual
                      cause can be identified and proper care provided. Several
                      diseases also cause dementia, such as Parkinson’s,
                      Alzheimer’s,Creutzfeldt-Jakob, Huntington’s and
                      multi-infarct or vascular disease, caused by multiple
                      strokes in the brain. What is Alzheimer’s?
                    </p>
                    <p>
                      Alzheimer’s disease is a progressive, degenerative disease
                      that is characterised by the loss of function and death of
                      nerve cells in several areas of the brain, that results in
                      impaired memory, thinking and behavior. Alzheimer’s
                      disease is the most common cause of dementia. It affects
                      an estimated 4 million American adults.
                    </p>
                  </div>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Card.Header>
                  <Accordion.Toggle as={Button} variant="link" eventKey="2">
                    What are the Warning Signs of Alzheimer’s?
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="2">
                  <div className="answer-body p-5">
                    <p>
                      The Alzheimer’s Association has developed a list of
                      warning signs that include common symptoms of Alzheimer’s
                      disease (some also apply to other dementias). Individuals
                      who exhibit several of these syptoms should see a
                      physician for a complete examination.
                    </p>
                    <ol>
                      <li>
                        Memory loss. One of the most common early warning signs
                        of dementia is forgetting recently learned information.
                        While it’s normal to forget appointments, names or
                        telephone numbers, those with dementia will forget such
                        things more often and not remember them later.
                      </li>
                      <li>
                        Difficulty performing familiar tasks. People with
                        dementia often find it hard to complete everyday tasks
                        that are so familiar we usually do not think about how
                        to do them. A person with Alzheimer’s may not know the
                        steps for preparing a meal, using a household appliance
                        or participating in a lifelong hobby.
                      </li>
                      <li>
                        Problems with language. Everyone has trouble finding the
                        right word sometimes, but a person with Alzheimer’s
                        often forgets simple words or subtitutes unusual words,
                        making his or her speech or writing hard to understand.
                      </li>
                      <li>
                        Disorientation to time and place. It’s normal to forget
                        the day of the week or where you’re going. But people
                        with Alzheimer’s disease can become lost on their own
                        street. They may forget where and how they got there,
                        and may not know how to get back home.
                      </li>
                      <li>
                        Poor or decreased judgement. No one has perfect
                        judgement all the time. Those with Alzheimer’s may dress
                        without regard to the weather, wearing several shirts on
                        a warm day or very little clothing in cold weather.
                        Those with dementia often show poor judgement about
                        money, giving away large sums to telemarketers or paying
                        for home repairs or products they don’t need.
                      </li>
                      <li>
                        Problems with abstract thinking. Balancing a checkbook
                        is a task that can be challenging for some. But a person
                        with Alzheimer’s may forget what the numbers represent
                        and what needs to be done with them.
                      </li>
                      <li>
                        Misplacing things. Anyone can temporarilly misplace a
                        wallet or key. A person with Alzheimer’s disease may put
                        things in unusual places, like an iron in the freezer or
                        a wristwatch in the sugar bowl.
                      </li>
                      <li>
                        Changes in mood or behavior. Everyone can become sad or
                        moody from time to time. Someone with Alzheimer’s
                        disease can show rapid mood swings-from calm to tears to
                        anger-for no apparent reason.
                      </li>
                      <li>
                        Changes in personality. Personalities ordinarilly chanfe
                        somewhat with age. But a person with Alzheimer’s can
                        change dramatically, becoming extremely confused,
                        suspicious, fearful or dependent on a family member.
                      </li>
                      <li>
                        Loss of initiative. Its normal to tire of housework,
                        business activities or social obligations at times. The
                        person with Alzheimer’s diseae may become very passive,
                        sitting in front of the television for hours, sleeping
                        more than usual or not wanting to do usual activities.
                      </li>
                    </ol>
                  </div>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Card.Header>
                  <Accordion.Toggle as={Button} variant="link" eventKey="3">
                    What is Parkinson’s disease?
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="3">
                  <div className="answer-body p-5">
                    <p>
                      Parkinson’s disease (PD) is a degenerative neurological
                      disorder of the brain related to a depletion of a
                      neurotransmitter called dopamine. The average age of
                      diagnosis is 60. The cause of PD is still under
                      investigation, however there may be multiple factors
                      including genetic predisposition and exposure to
                      environmental toxins. Syptoms can include: Rigidity or
                      stiffnesss of arms, legs or neck tremors, mostly in the
                      hands (at rest), instability in posture or balance,
                      slowness in movement. Secondary syptoms may include facial
                      “masking”, depression, confusion, difficulties in speech
                      or swallowing.
                    </p>
                  </div>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Card.Header>
                  <Accordion.Toggle as={Button} variant="link" eventKey="4">
                    Protecting Caregivers Health
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="4">
                  <div className="answer-body p-5">
                    <p>
                      How do you know when it is time to seek help for the care
                      of a loved one in order to maintain your own health?
                    </p>
                    <p>
                      A study of elderly spouse caregivers, aged 60 to 96; found
                      that caregivers who experience mental and emotional strain
                      have 63% higher risk of dying than non-caregivers.
                    </p>
                    <p>
                      Caregivers are often so concerned with care for their
                      relatives needs, that they lose sight of their own well
                      being.
                    </p>
                    <p>
                      Please use the caregiver self assessment questionaire
                      below to help assess your need for help.
                    </p>
                    <p>During the past week or so, I have…</p>
                    <ol>
                      <li>Had trouble keeping my mind on what I was doing.</li>
                      <li>Felt that I couldn’t leave my relative alone.</li>
                      <li>Had difficulty making decisions.</li>
                      <li>Felt completely overwhelmed.</li>
                      <li>Felt useless and unneeded.</li>
                      <li>Felt lonely.</li>
                      <li>
                        Been upset that my relative has changed so much from
                        his/her former self.
                      </li>
                      <li>Felt a loss of privacy and/or personal time.</li>
                      <li>Been edgy and irritable.</li>
                      <li>
                        Had sleep disturbed because of caring for relative.
                      </li>
                      <li>Had a crying spell or spells.</li>
                    </ol>
                    <p>
                      Felt strained between work and family responsibilities.
                    </p>
                    <ol>
                      <li>Had back pain.</li>
                      <li>
                        Felt ill (headaches, stomach problems or common cold).
                      </li>
                      <li>
                        Been dissatisfied with the support my family has given
                        me.
                      </li>
                      <li>
                        Found that my relatives living situation to be
                        inconvenient or a barrier to care.
                      </li>
                      <li>
                        On a scale of 1 to 10, with 1 being “not stressed” to 10
                        being “extremely stressefull”, please rate your current
                        level of stress.
                      </li>
                      <li>
                        On a scale of 1 to 10, with 1 being “very healthy” to 10
                        being “extremely ill” please rate your current health
                        compared to what it was this time last year.
                      </li>
                    </ol>
                  </div>
                </Accordion.Collapse>
              </Card>
            </Accordion>
            <div className="faq-footer-content p-5">
              <p className="font-italic">
                To determine the score total the number of “yes” responses.
              </p>
              <p>
                Chances are you are experiencing a high degree of distress if
                your total score is 10 or more; you answered “yes” to questions
                4 and 11 or your score on either question 17 or 18 was 6 or
                higher.
              </p>
              <p>Next Steps:</p>
              <ul>
                <li>Consider seeing a doctor for a check-up for yourself.</li>
                <li>
                  Consider having some relief from caregiving. Contact Assured
                  Assisted Living. Short respite and daycare is also available.
                </li>
                <li>Consider joining a support group.</li>
              </ul>
              <p>
                <span className="font-weight-bold">
                  Assured Assisted Living Homes
                </span>{" "}
                knows the significance of informed choices. May the information
                that you read here has been helpful in understanding conditions.
                If you have other questions, please contact us at – .
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default Contact
